<template lang='pug'>
.list-container
    van-search(v-model='q', placeholder='搜索提交记录', @search='loadData(true)')
    van-tabs(
        v-model='active',
        @change='loadData(true)',
        animated,
        type="card"
    )
        van-tab(
            :title='status.remark',
            v-for='status in statusList',
            :name='status.id'
        )
            van-list(
                v-if='list[status.id]',
                v-model='list[status.id].loading',
                :finished='list[status.id].finished',
                finished-text='没有更多了',
                :immediate-check='false',
                @load='load'
            )
                slot(name='head', :status='status')
                div(v-for='item in list[status.id].data', :key='item.id')
                    slot(:item='item', :status='status')
</template>

<script>
import { GetAuditList, GetProjectDetail, GetSubmitList } from '@/service/ticket'
import { mapActions } from 'vuex'
import day from 'dayjs'

export default {
    props: ['projectId', 'exclude', 'listDic'],
    data() {
        return {
            active: -1,
            isAStaff: false,
            project: {},
            list: {},
            q: '',
            staffId: null,
            role: ''
        }
    },
    computed: {
        curList() {
            if (this.active === -1) return this.list[-1]
            return this.list[this.active]
        },
        statusList() {
            if (this.listDic) return this.listDic
            if (!this.project.status) return []
            let { status } = this.project
            if (this.exclude) {
                status = status.filter(item => !this.exclude.test(item.remark))
            }
            return [{ remark: '全部', id: -1 }, ...status]
        }
    },
    methods: {
        ...mapActions(['isStaff', 'getRole']),
        load() {
            this.curList.paganation.index++
            this.loadData()
        },
        async loadData(refresh) {
            const { paganation } = this.curList
            if (refresh) {
                paganation.index = 1
                paganation.size = 10
            }
            const { index, size } = paganation
            const t = { projectId: this.projectId, index, size, q: this.q }
            if (this.listDic) {
                Object.assign(t, {
                    statusIds: ~this.active ? this.active.split(',') : null
                })
            } else {
                Object.assign(t, {
                    statusId: ~this.active ? this.active : null
                })
            }
            this.curList.loading = true
            let data
            if (this.isAStaff) {
                ({ staffId: this.staffId, role: this.role } = await this.getRole(this.projectId))
                data = await GetAuditList(Object.assign({ staffId: this.staffId }, t))
            } else {
                data = await GetSubmitList(t)
            }
            data.data.forEach(item => {
                item.createdAt = day(item.createdAt).format("YYYY/MM/DD HH:mm")
            })
            if (refresh) {
                this.curList.data = data.data
            } else {
                this.curList.data = this.curList.data.concat(data.data)
            }
            this.curList.loading = false
            paganation.total = data.total
            if (index * size >= data.total) {
                this.curList.finished = true
            }
            this.$emit('loaded', { data: this.curList.data, status: this.active })
        },
        async initList() {
            try {
                [this.isAStaff, this.project] = await Promise.all([this.isStaff(this.projectId), GetProjectDetail(this.projectId)])
                let initData = {}, statuses = []
                if (this.listDic) {
                    statuses = this.listDic
                } else {
                    initData = {
                        '-1': {
                            data: [],
                            finished: false,
                            loading: false,
                            paganation: {
                                index: 1,
                                size: 10,
                                total: 0
                            }
                        }
                    }
                    statuses = this.project.status
                }
                this.list = statuses.reduce((pre, cur) => {
                    // if (this.active == null) {
                    //     this.active = cur.id
                    // }
                    pre[cur.id] = {
                        data: [],
                        finished: false,
                        loading: false,
                        paganation: {
                            index: 1,
                            size: 10,
                            total: 0
                        }
                    }
                    return pre
                }, initData)
                await this.loadData()
                this.$emit('load', { project: this.project, staffId: this.staffId })
            } catch (error) {
                this.$message.fail(error.message)
            }
        }
    },
    created() {
        this.initList()
    }
}
</script>

<style scoped lang='less'>
/deep/.van-tabs__wrap {
    margin-bottom: 1rem;
}
</style>